import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getToken,
  setToken
} from '@/utils/token' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import local from "@/utils/local";

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login', '/'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();

  // set page title
  document.title = getPageTitle(to.meta.title);

  // determine whether the user has logged in
  const hasToken = getToken();
  var visitor = false;
  // if (local.get("visitor")) {
  //   visitor = JSON.parse(local.get("visitor"));
  // }
  console.log("hasToken", hasToken);
  // //临时使用
  // setToken("1");
  // //临时使用end
  if (hasToken || visitor) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({
        path: "/",
      });
      NProgress.done(); // hack: https://github.com/PanJiaChen/vue-element-admin/pull/2939
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles || true) {
        next();
      } else {
        try {
          // get user info
          // note: roles must be a object array! such as: ['admin'] or ,['developer','editor']
          // const roles = await store.dispatch('user/getInfo')
          await store.dispatch("user/getInfo"); //内容执行 之后需要他的回调
          const roles = ["admin"]; //与页面绑定的权限，并非真实权限
          // console.log("跳转", router);
          // generate accessible routes map based on roles
          // const accessRoutes = await store.dispatch('permission/generateRoutes', roles); //控制页面是否展示，与权限区别
          // await store.dispatch('permission/generateRoutes', roles); //控制页面是否展示，与权限区别
          // 报错

          // dynamically add accessible routes
          // router.addRoutes(accessRoutes)

          next({
            ...to,
            replace: true,
          });
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch("user/resetToken");
          Message.error({
            type: "error ",
            message: error || "Has Error",
          });
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next();
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`);
      // next();
      NProgress.done();
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})